(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beautifully-haunted"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.bh__photo-toggle');
    if (!button) return;
    const card = button.closest('.bh__product-card');
    if (!card) return;
    const showSecond = button.getAttribute('aria-pressed') !== 'true';
    card.classList.toggle('is-second', showSecond);
    button.setAttribute('aria-pressed', String(showSecond));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kkb-event-landing"] && !Shopify.designMode) return;
  try {
    
  function setupKkbEvent(root) {
    root.querySelectorAll('[data-kkb-swap]').forEach(function(button) { button.hidden = false; });
  }
  document.querySelectorAll('.kkb-event').forEach(setupKkbEvent);
  document.addEventListener('shopify:section:load', function(event) { setupKkbEvent(event.target); });
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-kkb-swap]');
    if (!button) return;
    const card = button.closest('[data-kkb-card]');
    if (!card) return;
    const second = card.classList.toggle('is-second');
    button.setAttribute('aria-pressed', String(second));
    const label = button.getAttribute('aria-label') || '';
    button.setAttribute('aria-label', label.replace(/: [12] \/ 2$/, second ? ': 2 / 2' : ': 1 / 2'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
